import axios from 'axios';

export default class Request {
    getPopupData() {
        return axios.get(`static/data/popup-data.json`)
            .then(res => {
                return res;
            })
            .catch(e => {
                console.log(e);
            })
    }
}



// WEBPACK FOOTER //
// ./src/rest/gets.js